<template>
<div>
    <pt-sub-title title="问答记录"></pt-sub-title>
    <div class="message-table">
    <table>
        <pt-message-table-item @widthItem="widthItem" label="创建时间">{{data.created_date}}</pt-message-table-item>
        <pt-message-table-item label="消费积分">{{data.pointsConsume?data.pointsConsume+'分':data.pointsConsume}}</pt-message-table-item>
        <pt-message-table-item label="主题">{{data.topic}}</pt-message-table-item>
        <pt-message-table-item label="预产期">{{data.expected_date}}</pt-message-table-item>
        <pt-message-table-item label="详细描述">
          <div>{{data.content}}</div>
          <template  v-if="data.picture&&data.picture.length>0">
            <div :class="$style['question-main-imgs']">
                <div  v-for="(item,index) in data.picture" :key="index" class="question-main-imgs-item">
                    <pt-img @click.native="onPreview(index)" :class="$style['picture-radius']" :isPublic="false" :src="item"></pt-img>
                </div>
            </div>
            </template>
        </pt-message-table-item>
        <pt-message-table-item label="状态">{{data.ask_status}}</pt-message-table-item>
    </table>
    <table :class="$style['question-answer-table']" v-if="answerList&&answerList.length">
        <tr>
            <td></td>
            <td>人员</td>
            <td>问答内容</td>
            <!-- <td>消费积分</td> -->
            <td>问答时间</td>
            <td>提问状态</td>
            <td v-if="is_edit">操作</td>
        </tr>
        <tr v-for="(item,index) in answerList" :key="index">
            <td>{{item.record_type}}</td>
            <td>{{item.name}}</td>
            <td class="detail-td">
              <div class="detail-content">{{item.content}}</div>
              <template  v-if="item.picture&&item.picture.length>0">
                <div :class="$style['question-main-imgs']">
                    <div  v-for="(etem,index) in item.picture" :key="index" class="question-main-imgs-item">
                        <pt-img @click="onPreviewItem(item.picture,index)" :class="$style['picture-radius']" :isPublic="false" :src="etem"></pt-img>
                    </div>
                </div>
              </template>
              </td>
            <!-- <td>{{item.pointsConsume?item.pointsConsume+'分':item.pointsConsume}}</td> -->
            <td>{{item.created_date}}</td>
            <td>{{item.recordType==='ASK'?(item.status==='BLOCKED'?'屏蔽':'正常'):null}}</td>
            <td v-if="is_edit">
              <el-button type="text" v-if="item.recordType==='ANSWER'" @click="getEditMessage(item)">编辑</el-button>
              <el-button type="text" class="button-red" v-if="item.recordType==='ASK'" @click="answerRecordsBlock(item.id)">屏蔽</el-button>
              <el-button type="text" class="button-red" @click="deleteRecord(item.id)">删除</el-button>
            </td>
        </tr>
    </table>
    <template v-if="askOperation">
    <table>
      <pt-message-table-item label="详细描述">
        <wt-input placeholder="请输入回答内容（最多输入200个字）" type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 5}" :max-length="200"
            :class="$style['input-style']"   v-model="form.content" data-vv-as="商品描述" name="name"  v-validate="'required'"></wt-input>
      </pt-message-table-item>
    </table>
    <div class="message-button-div" >
    <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
    <el-button type="primary" @click="edit" v-if="!is_edit">编辑</el-button>
    <template v-if="is_edit">
    <el-button type="primary" plain @click="cancelEdit">取消</el-button>
    <el-button type="danger" plain @click="closeASK">关闭</el-button>
    <el-button type="danger" plain @click="deleteQuestion">删除</el-button>
    </template>
    </div>
    </template>
    </div>
    <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :initialIndex="currentIndex" :value="images" :loop="false"></wt-image-preview>
</div>
</template>
<script>
import emitter from '@/mixins/emitter'
export default {
  mixins: [emitter],
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    answerList: Array,
    submitLoading: Boolean,
    isEdit: Boolean
  },
  data () {
    return {
      form: {},
      tdMaxWidth: null,
      is_edit: this.isEdit,
      answerId: null,
      privateResourcesUrl: this.$privateResourcesUrl,
      currentIndex: 0,
      previewVisible: false
    }
  },
  computed: {
    // 是否显示问答的操作
    askOperation () {
      return this.data.status !== 'CLOSED'
    }
  },
  watch: {
    submitLoading (val) {
      if (!val) {
        this.form.content = null
      }
    }
  },
  methods: {
    onPreviewItem (picture, index) {
      this.images = []
      picture.forEach(item => {
        this.images.push(this.privateResourcesUrl + item)
      })
      this.previewVisible = true
      this.currentIndex = index
    },
    onPreview (index) {
      this.images = []
      this.data.picture.forEach(item => {
        this.images.push(this.privateResourcesUrl + item)
      })
      this.previewVisible = true
      this.currentIndex = index
    },
    closePreview () {
      this.previewVisible = false
    },
    widthItem (val) {
      this.tdMaxWidth = val
    },
    submit () {
      let data = {
        ...this.form,
        questionId: this.data.id
      }
      if (!data.content) {
        this.$message.error('请填写回答内容')
      } else {
        this.dispatch('pt-obs-department-detail', 'answerTheAsk', data)
        this.$emit('answerTheAsk', data)
      }
    },
    edit () {
      this.is_edit = true
    },
    answerRecordsBlock (id) {
      this.dispatch('pt-obs-department-detail', 'answerRecordsBlock', id)
    },
    deleteRecord (id) {
      this.dispatch('pt-obs-department-detail', 'deleteRecord', id)
    },
    getEditMessage (val) {
      this.$set(this.form, 'content', val.content)
      this.form.id = val.id
      // this.form.description = val.content
    },
    cancelEdit () {
      this.is_edit = false
    },
    closeASK () {
      this.dispatch('pt-obs-department-detail', 'closeASK', this.data.id)
    },
    deleteQuestion () {
      this.dispatch('pt-obs-department-detail', 'deleteQuestion', this.data.id)
    }
  }
}
</script>
<style module lang="less">
@import "~less/var.less";
.question-main-imgs{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  :global{
  .question-main-imgs-item{
    width: 150px;
    height: 150px;
    justify-items: center;
    align-items: center;
    display: flex;
    margin-right: 20px;
    img{
      width: 100%;
      max-height: 100%;
    }
  }

  }
}
.question-answer-table{
  color: #585558;
  width: 100%;
  margin:20px 0;
   :first-child{
      color:@mainColor;
    }
  tr{
    :first-child{
      color:@mainColor;
    }
    td{
      padding: 10px;
      max-width: 150px;
      border: none
    }
    :global{
    .detail-td{
      max-width: 300px;
      .detail-content{
        color: #585558;
      }
      .question-main-imgs-item{

      }
      img{
        margin-top: 5px
      }
    }
    .button-red{
      span{
      color: red
      }
    }
    }
  }
  tr:nth-child(2n){ background: #FBF8FC;}
}
.input-style{
  width: 100%;
  min-width: 500Px;
}
</style>
